import { useFrame } from '@react-three/fiber';
export const Render = ({ ...props }) => {
  useFrame(({ gl, scene, camera }) => {
    gl.setRenderTarget(null);
    gl.render(scene, camera);
  }, props.renderPriority);

  return <></>;
};
